import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import i18n from '../i18n';
import { retrieveStorageById, patchStorage } from '../helpers/storeService';
import { useParams } from 'react-router';
import useRouting from '../hooks/useRouting';
import { ChatContext } from '../contexts/ChatContext';
import FlowChatBox from '../components/FlowChatBox';
import { getNestedObject } from '../helpers/objectService';

const FlowHomeOwnerMobile = () => {
  const { id, affinity, insuranceType, currentProperty } = useParams();
  const { renderNextRoute } = useRouting();
  const { data } = retrieveStorageById(id, affinity, insuranceType) || {};
  const { risk_addresses } = data;
  const { addQuestion, addAnswer } = useContext(ChatContext);
  const [defaultValues, setDefaultValues] = useState({});

  useEffect(() => {
    const question = {
      message: i18n.t('Are you a <span>tenant or the landlord</span>?'),
      slug: 'is_landlord',
    };
    addQuestion(question);
    loadDefaultValues();
  }, []);

  const loadDefaultValues = async () => {
    const defaultValuesTemp = {
      is_landlord: getNestedObject(risk_addresses, [
        [currentProperty],
        'is_landlord',
      ]),
    };
    setDefaultValues(defaultValuesTemp);
  };

  const submitHandler = () => {
    let payload = {
      is_landlord: defaultValues.is_landlord,
    };
    patchStorage({
      payload: payload,
      path: ['risk_addresses', [currentProperty]],
      id,
      affinity,
      insuranceType,
    });

    const answer = {
      message: defaultValues.is_landlord
        ? i18n.t('I am the landlord')
        : i18n.t('I am a tenant'),
      slug: 'is_landlord',
    };
    addAnswer(answer);

    renderNextRoute(1, { property: currentProperty });
  };

  return (
    <Container>
      <FlowChatBox />
      <RightContainer>
        <AddressToInsureQ>
          <StyledButton
            active={defaultValues.is_landlord === true}
            onClick={() => {
              defaultValues.is_landlord = true;
              submitHandler();
            }}
          >
            {i18n.t('Landlord')}
          </StyledButton>
          <StyledButton
            active={defaultValues?.is_landlord === false}
            onClick={() => {
              defaultValues.is_landlord = false;
              submitHandler();
            }}
          >
            {i18n.t('Tenant')}
          </StyledButton>
        </AddressToInsureQ>
      </RightContainer>
    </Container>
  );
};

const AddressToInsureQ = styled.div`
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 45% 45%;
  width: 100%;
  justify-content: center;
`;

const StyledButton = styled.button`
  background-color: ${({ active, theme }) =>
    active ? theme.brand.primary : '#ffffff'};
  border: ${({ active, theme }) =>
    active ? 'none' : `2px solid ${theme.brand.primary}`};
  border-radius: 5px;
  color: ${({ active, theme }) => (active ? '#ffffff' : theme.brand.primary)};
  cursor: pointer;
  font-weight: bold;
  font-size: 1.4rem;
  height: 4rem;
  &:focus {
    outline: 0;
  }
  &:hover {
    background-color: ${({ theme }) => theme.brand.light};
    color: white;
  }
`;

const Container = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  width: 100%;
  overflow: hidden;
`;

const RightContainer = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: space-between;

  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  padding: 2rem;
`;

export default FlowHomeOwnerMobile;
